import React from 'react'
import PaginationLayout from '../old/PaginationLayout'
import useFilterValue from '../hooks/use-filter-value'
import useWillConstrain from '../hooks/use-will-constrain'

function PaginationFilter (props) {
  const [page, setPage] = useFilterValue('pagination', 1, 'page', false, true)
  const [pages] = useFilterValue('pagination', 1, 'pages', false, true)

  const handleChangePage = (page) => {
    setPage(page)
  }

  useWillConstrain(props.name, page)

  const Layout = PaginationFilter._layout || props.layout

  return (
    <Layout page={page} pages={pages} onChange={handleChangePage} />
  )
}

PaginationFilter._layout = null

PaginationFilter.setLayout = (layout) => {
  PaginationFilter._layout = layout
}

PaginationFilter.defaultProps = {
  name: '$page',
  layout: PaginationLayout
}

export default PaginationFilter
